<div class="flex-column gap pb-3">
    <app-service-settings-common
        [defaultData]="store.sickNotesSettings()"
        [hideShareWithOtherServicesInput]="true"
        [title]="'service.settings.sick-notes.header'"
    >
        <ng-template #additionalContent>
            <p-divider></p-divider>
            <app-text-input
                id="icpe"
                [form]="form"
                label="service.settings.sick-notes.icpe"
            ></app-text-input>
        </ng-template>
        <ng-template #footer>
            <app-action-buttons
                (primaryClickEvent)="save()"
                (secondaryClickEvent)="cancel()"
            ></app-action-buttons>
        </ng-template>
    </app-service-settings-common>

    <app-service-doctors-secrets
        [serviceId]="Number(routeParams.serviceId())"
        [secretType]="UserSecretTypeEnum.QUAL_CERT"
        [title]="'service.settings.eprescriptions.doctorsCertificates'"
    ></app-service-doctors-secrets>

    <app-service-doctors-secrets
        [serviceId]="Number(routeParams.serviceId())"
        [secretType]="UserSecretTypeEnum.SUKL_IDENTITY"
        [title]="'service.settings.eprescriptions.doctorsSecrets'"
    ></app-service-doctors-secrets>

    <app-service-certificates-settings
        [serviceId]="Number(routeParams.serviceId())"
    ></app-service-certificates-settings>
</div>
